// A reason, written out: why a ban is set or lifted, why the audit log is read. A few lines of text
// rather than one, because a reason is read later by someone who was not there. The kit's Field does
// the label, the description, the error and their wiring; the kit has no multi-line input of its
// own, so this is its `clav-input` on a `<textarea>`, as the settings renderer's JSON editor is.

import { Field } from '@clavian/ui-web';
import type { ReactNode } from 'react';

export interface ReasonFieldProps {
  readonly label: ReactNode;
  readonly description?: ReactNode;
  readonly error?: ReactNode;
  readonly value: string;
  readonly maxLength: number;
  readonly onChange: (value: string) => void;
  readonly disabled?: boolean;
}

export function ReasonField({ label, description, error, value, maxLength, onChange, disabled }: ReasonFieldProps) {
  return (
    <Field label={label} description={description} error={error} required>
      {(control) => (
        <textarea
          id={control.id}
          aria-describedby={control['aria-describedby']}
          aria-invalid={control['aria-invalid']}
          required
          className="clav-input console-hq-reason"
          rows={3}
          maxLength={maxLength}
          disabled={disabled}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
      )}
    </Field>
  );
}
